import logo from './logo-head.png';
import './App.css';

function App() {
  return (
    <div className="page">
      <div className="noise" />

      <main className="hero">
        <div className="badge">Coming Soon</div>

        <div className="brand">
          <div className="brand-icon">
            <img src={logo} alt="KoDA mascot" />
          </div>
          <h1 className="brand-name">KoDA</h1>
        </div>

        <p className="tagline">
          Your personal recipe companion.<br />
          Discover, save, and cook with confidence.
        </p>

        <div className="features">
          <div className="feature">
            <span className="feature-icon">🥘</span>
            <span>Smart Recipes</span>
          </div>
          <div className="feature">
            <span className="feature-icon">📋</span>
            <span>Meal Planning</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🛒</span>
            <span>Grocery Lists</span>
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>© {new Date().getFullYear()} KoDA Recipes. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
